<template>
  <div>
    <el-table v-if="mvms" :data="mvms.rows" style="width: 100%; padding-top: 15px">
      <el-table-column label="機台編號">
        <template slot-scope="scope">
          {{ scope.row.AssetNo }}
        </template>
      </el-table-column>

      <el-table-column label="客戶">
        <template slot-scope="scope">
          {{ scope.row.client.name }}
        </template>
      </el-table-column>

      <el-table-column label="放置地點">
        <template slot-scope="scope">
          {{ scope.row.locate.name }}
        </template>
      </el-table-column>

      <el-table-column label="巡補員">
        <template slot-scope="scope">
          {{ scope.row.user.name }}
        </template>
      </el-table-column>

      <el-table-column label="狀態" align="center">
        <template slot-scope="scope">
          <statusTag :status="scope.row.Status" :updated-at="scope.row.updated_at" />
        </template>
      </el-table-column>

      <el-table-column label="最後連線時間">
        <template slot-scope="scope">
          <lastUpdate :updated-at="scope.row.updated_at" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getMvms } from '@/api/dashboard'
import { mapGetters, mapActions } from 'vuex'
import statusTag from '@/views/mvms/components/statusTag.vue'
import lastUpdate from '@/views/mvms/components/lastUpdate.vue'
export default {
  filters: {
    statusFilterText(status) {
      const statusMap = {
        1: '在線',
        0: '離線',
        4: '未註冊'
      }
      return statusMap[status]
    },
    statusColorFilter(key) {
      const map = {
        1: 'success',
        2: 'danger',
        4: 'warning'
      }
      return map[key] ? map[key] : 'success'
    }
  },
  data() {
    return {
      list: null,
      mvms: null
    }
  },

  computed: {
    ...mapGetters('variable', ['company_id'])
  },
  watch: {
    async company_id() {
      this.mvms = await getMvms({ company_id: this.company_id })
    }
  },
  async created() {
    this.mvms = await getMvms({ company_id: this.company_id })
  },
  components: {
    statusTag,
    lastUpdate
  },
  methods: {}
}
</script>
